<template>
    <div>
        <div class="d-flex align-items-start">
            <recipient-display
                v-bind:recipient="recipient"
                v-bind:tag-only="isEditMode"
                class="flex-grow-1" />
            <pc-button
                v-if="canResend && !recipient.Status.IsReady && !isEditMode"
                class="edit-recipient-button ms-3"
                small
                v-on:click="editRecipient">
                {{ editText }}
            </pc-button>
        </div>
        <div v-if="isEditMode">
            <div class="row g-0 mb-2">
                <pc-input
                    v-model="recipientEmail"
                    v-bind:class="responsiveClasses.editRecipientEmail"
                    v-bind:validator="emailValidator"
                    v-bind:label="emailLabel"
                    inputmode="email"
                    required />
                <pc-input
                    v-model="recipientFirst"
                    v-bind:class="responsiveClasses.editRecipientName"
                    v-bind:validator="requiredValidator"
                    v-bind:label="firstNameLabel"
                    required />
                <pc-input
                    v-model="recipientLast"
                    v-bind:class="responsiveClasses.editRecipientName"
                    v-bind:validator="requiredValidator"
                    v-bind:label="lastNameLabel"
                    required />
            </div>
            <div class="d-flex align-items-center justify-content-end">
                <pc-button v-on:click="editRecipientCancel">
                    {{ cancelText }}
                </pc-button>
                <pc-button
                    class="ms-2"
                    primary
                    v-on:click="editRecipientOk">
                    {{ okText }}
                </pc-button>
            </div>
        </div>
    </div>
</template>
<script>
    import { WIDE_BP } from "Projects/SharedCapsules/_sharedCapsuleBase";
    import recipientDisplay from "./recipientDisplay.vue";
    import { getValidator, VALIDATOR_TYPES } from "Validation/validator";
    import { ValidationHub } from "Validation/validationHub";
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "./i18n/eSignatureRecipientControl.i18n";
    import { KEYS as COMMON_KEYS, NAMESPACE as COMMON_NAMESPACE } from "I18n/common.i18n";
    import { getResponsiveClassMap } from "Responsive/manager";

    const responsiveConfig = {
        editRecipientEmail: {
            col: { xs: 12, [WIDE_BP.name]: 6 }
        },
        editRecipientName: {
            col: { xs: 12, [WIDE_BP.name]: 3 },
            ps: { [WIDE_BP.name]: 2 }
        }
    };

    export default {
        components: {
            recipientDisplay
        },
        inject: {
            viewport: {
                from: "viewport",
                default: null
            }
        },
        provide() {
            return {
                validationHub: this.validationHub
            };
        },
        props: {
            recipient: { type: Object, required: true },
            canResend: { type: Boolean, required: false, default: false }
        },
        emits: ["toggle-edit", "update-recipient"],
        data() {
            return {
                isEditMode: false,
                recipientFirst: this.recipient.FirstName,
                recipientLast: this.recipient.LastName,
                recipientEmail: this.recipient.Email,
                emailValidator: getValidator(this.$app, [VALIDATOR_TYPES.email, VALIDATOR_TYPES.required]),
                requiredValidator: getValidator(this.$app, VALIDATOR_TYPES.required),
                validationHub: new ValidationHub()
            };
        },
        computed: {
            responsiveClasses() {
                return getResponsiveClassMap(this.viewport, responsiveConfig);
            },
            ...mapI18n(KEYS, NAMESPACE),
            ...mapI18n(COMMON_KEYS, COMMON_NAMESPACE)
        },
        watch: {
            isEditMode(value) {
                this.$emit("toggle-edit", value);
            }
        },
        methods: {
            editRecipient() {
                this.isEditMode = true;
            },
            editRecipientOk() {
                if (this.validationHub.validate()) {
                    return;
                }

                this.isEditMode = false;

                // Don't fire a changed event if there haven't actually been any
                // changes
                if (
                    this.recipientFirst === this.recipient.FirstName &&
                    this.recipientLast === this.recipient.LastName &&
                    this.recipientEmail === this.recipient.Email
                ) {
                    return;
                }

                const updates = {
                    first: this.recipientFirst,
                    last: this.recipientLast,
                    email: this.recipientEmail
                };

                this.$emit("update-recipient", updates);
            },
            editRecipientCancel() {
                this.isEditMode = false;
                this.recipientFirst = this.recipient.FirstName;
                this.recipientLast = this.recipient.LastName;
                this.recipientEmail = this.recipient.Email;
            }
        }
    };
</script>
<style lang="scss" scoped>
    .edit-recipient-button {
        min-width: 5rem !important;
    }
</style>
